define('plugin/invoice/view/InvoiceListView',['require','lib/view/LayoutView','plugin/invoice/view/InvoiceListCollectionView','lib/view/UnwrapRegion','lib/pager/view/PagerView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var InvoiceListCollectionView = require('plugin/invoice/view/InvoiceListCollectionView');
    var UnwrapRegion = require('lib/view/UnwrapRegion');
    var PagerView = require('lib/pager/view/PagerView');

    /**
     * invoice layout view (invoices container)
     *
     * @class InvoiceListView
     */
    return LayoutView.extend({

        template: '#invoice_list_view',
        regions: {
            'list': {
                selector: '#sb_invoice_list_container',
                regionClass: UnwrapRegion
            },
            'pager': '#sb_invoice_pager_container'
        },

        onShow: function () {
            this.showChildView('list', new InvoiceListCollectionView({
                collection: this.getOption('collection')
            }));
            this.showChildView('pager', new PagerView({
                pager: this.getOption('collection').getPager(),
                url: this.getOption('url')
            }));
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this), {
                label: this.getOption('label'),
                wrap: this.getOption('wrap')
            });
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'my_invoices'
            });
        }

    });

});
